import { EmptyState } from '@/components/layout/empty-state';
import { TrendingUp } from 'lucide-react';

// Performance / CLV / equity curve. V2 — needs the CLV tracker (architecture
// § 14) which depends on Pinnacle closing odds and a daily cron we haven't
// built yet. Honest empty state explaining what's coming.

export function PerformancePage() {
  return (
    <EmptyState
      title="RENDIMIENTO"
      description="Equity curve, ROI, Sharpe, Max DD, Win rate y CLV proyectado."
      value="V2"
      unit="pendiente"
      hint="Las métricas de rendimiento se calculan cuando empieces a ejecutar picks (Sharpe, ROI) y el cron de cierre de Pinnacle complete (CLV). Disponible en V2 según architecture § 14."
      icon={TrendingUp}
      badge="V2"
    />
  );
}
